var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Date",
                  type: "date",
                  "hide-details": "auto",
                  "error-messages": _vm.duckEggCollectionStorePostErrors.date
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6", md: "6" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Revenue Source",
                  "hide-details": "auto",
                  dense: "",
                  items: _vm.duckEggCollectorList,
                  "item-value": "id",
                  "item-text": "code",
                  loading: _vm.duckEggCollectorGetting,
                  "error-messages":
                    _vm.duckEggCollectionStorePostErrors.revenue_source_id
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "mr-2",
                            class:
                              _vm.revenueSourceCodeColor(item.updated_at) +
                              "--text"
                          },
                          [_vm._v(_vm._s(item.code))]
                        ),
                        _c("small", { staticClass: "blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.revenueSourceId,
                  callback: function($$v) {
                    _vm.revenueSourceId = $$v
                  },
                  expression: "revenueSourceId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Good",
                  type: "number",
                  "hide-details": "auto",
                  dense: "",
                  "error-messages": _vm.duckEggCollectionStorePostErrors.good
                },
                model: {
                  value: _vm.good,
                  callback: function($$v) {
                    _vm.good = $$v
                  },
                  expression: "good"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Reject",
                  type: "number",
                  "hide-details": "auto",
                  dense: "",
                  "error-messages": _vm.duckEggCollectionStorePostErrors.reject
                },
                model: {
                  value: _vm.reject,
                  callback: function($$v) {
                    _vm.reject = $$v
                  },
                  expression: "reject"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Cracked",
                  type: "number",
                  "hide-details": "auto",
                  dense: "",
                  "error-messages": _vm.duckEggCollectionStorePostErrors.cracked
                },
                model: {
                  value: _vm.cracked,
                  callback: function($$v) {
                    _vm.cracked = $$v
                  },
                  expression: "cracked"
                }
              })
            ],
            1
          ),
          !_vm.editMode
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green",
                        block: "",
                        small: "",
                        dark: "",
                        loading: _vm.duckEggCollectionStorePosting
                      },
                      on: { click: _vm.store }
                    },
                    [_c("span", [_vm._v("save")])]
                  )
                ],
                1
              )
            : _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "yellow darken-3",
                                block: "",
                                small: "",
                                dark: "",
                                loading: _vm.duckEggCollectionStorePosting
                              },
                              on: { click: _vm.update }
                            },
                            [_c("span", [_vm._v("update")])]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "red",
                                block: "",
                                small: "",
                                dark: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.editMode = false
                                }
                              }
                            },
                            [_c("span", [_vm._v("cancel")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }